module.exports = __webpack_public_path__ + "static/media/loading-bars.41cddf22.svg";